// Constant
import { FAKE_RESPONSE } from '../shared.constant'

// Interfaces
import { IAssessmentSupportDocumentApiListResponse } from 'interfaces/back-office/assessment/support-document/support-document-api.interface'

export const ASSESSMENT_SUPPORT_DOCUMENT_LIST: IAssessmentSupportDocumentApiListResponse = {
  ...FAKE_RESPONSE,
  res: {
    message: 'Get assessment support document list success',
    success: '1',
    data: [
      {
        id: 1,
        preconditionTypeName: 'asdsad',
        userFileBlobId: 'asdsa',
        userOriginalFileName: 'asdasd',
      },
    ],
  },
}
